export interface SpecialCase {
  id: string;
  title: string;
  description: string;
  domesticCoordinator: boolean,
  examTaskGroupCoordinator: boolean,
  examiningTeamChairman: boolean,
  techAdmin: boolean
}

export interface ISpecialCaseTitles {
  specialCaseId: string;
  title: string;
}

export interface Recipients {
  domesticCoordinator: boolean,
  examTaskGroupCoordinator: boolean,
  examiningTeamChairman: boolean,
  techAdmin: boolean
}

export type SpecialCasesSortBy = 'title' | 'description' | 'recipients';

export interface SpecialCasesTableItem {
  [key: string]: string | JSX.Element;
  id: string;
  title: string;
  description: string;
  recipients: JSX.Element;
  actions: JSX.Element;
}

export interface SpecialCaseFilter {
  title: string;
  description: string;
  recipients: string[];
}

export interface SpecialCaseFilterElements {
  recipients: JSX.Element;
}

export enum Recipient {
  KK,
  KGZ,
  PZE,
  AT
}

export enum WorkMode {
  ADD,
  EDIT,
}

export enum SpecialCaseResult {
  TitleAlreadyExists = 0,
  Success = 1,
  Fail = 2,
  AssessmentSessionIsOpen = 3
}